module.exports = __webpack_public_path__ + "img/046-bookmark.4a139f08.svg";